import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import './settings.css';
import { Button, Menu, Dropdown, message, Modal } from 'antd';
import { fetchlink } from '../../utils/link.js';
import {
  DeleteOutlined,
  SettingOutlined,
  ExclamationCircleOutlined,
  EditOutlined,
} from '@ant-design/icons';
import { getJwt } from '../../auth/auth';

const { confirm } = Modal;

export function Settings(props) {
  const [loading, setLoading] = useState(false);
  const routerHistory = useHistory();

  const changeContract = (id) => {
    routerHistory.push(`/admin/editcontract/${id}`);
  };

  function showDeleteConfirm(id) {
    confirm({
      title: 'Ertu viss um að þú viljir eyða þessum samning?',
      icon: <ExclamationCircleOutlined />,
      content: 'Ekki er hægt að afturkalla þessa aðgerð!',
      okText: 'Eyða',
      okType: 'danger',
      cancelText: 'Nei',
      async onOk() {
        setLoading(true);

        const jwt = getJwt();

        await fetch(`${fetchlink}/contracts/delete/${id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${jwt.token}`,
          },
        });
        message.info('Samningi hefur verið eytt');
        setLoading(false);
        props.reFetch();
      },
      onCancel() {
        setLoading(false);
      },
    });
  }

  const handleClick = async (event, id) => {
    setLoading(true);
    event.key === '0' ? changeContract(id) : showDeleteConfirm(id);
  };

  return (
    <>
      <Dropdown
        disabled={loading}
        overlay={
          <Menu onClick={(event) => handleClick(event, props.id)}>
            <Menu.Item key='0'>
              <Button icon={<EditOutlined />} type='link'>
                Breyta samning
              </Button>
            </Menu.Item>
            <Menu.Item key='1'>
              <Button danger icon={<DeleteOutlined />} type='link'>
                Eyða samning
              </Button>
            </Menu.Item>
          </Menu>
        }
        trigger={['click']}
      >
        <Button
          type={props.isContractPage ? 'primary' : 'link'}
          className='settingsBtn'
          icon={<SettingOutlined />}
        >
          {!props.displayIconOnly && <> Stillingar</>}
        </Button>
      </Dropdown>
    </>
  );
}
